import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
// import { useAuth } from "../Auth/Auth";
import {apiHeader} from '../../../utils/apiHeader'
import axios from "axios";
import { globalConfig } from "../../../config/config";
// const querystring = require("querystring");

const ManageContentTemplateTypes = ({ location }) => {
  let parms = new URLSearchParams(location.search);
  const [contentTemplateTypeCodes, setContentTemplateTypeCodes] = useState([]);
  const [message, setMessage] = useState("");
  const {token,userMetadata}=useAuth()
  const history = useHistory();
  const [state, setState] = useState({
    contentTemplateTypeId: parseInt(parms.get("id")),
    contentTemplateValueCode: 0,
    contentTemplateTypeCdata: "",
    contentTemplateTypeBdata: "",
    securityContextId: 0,
    createUser: 0,
    createDate: new Date().toISOString(),
    lastUpdateUser: 0,
    lastUpdateDate: new Date().toISOString(),
    contentTemplateTypeDescr: "",
  });
  useEffect(() => {
    handleOnLoad();
  }, []);
  function handleSave(event) {
    console.log("handling save 1");

    event.preventDefault();
    console.log("handling save");

    var url = `${globalConfig.apiDatahubUrl}/content-template-types/${state.contentTemplateTypeId}`;

    axios
      .patch(url, state, apiHeader(token))
      .then((response) => {
        console.log("response.data");
        console.log(response.status + ":" + response.data.contentInputSourceId);

        if (response.status === 200) {
          setMessage("Success");
          setInterval(() => {
            window.location.reload();
          }, 1000);
        } else {
          setMessage("Failed");
        }
        console.log(message);
        event.preventDefault();
      })
      .catch((err) => {
        console.log("error - " + err);
      });
    console.log("message info - " + message);
  }
  function handleChange(event) {
    console.log(event);
    var target = event.target;
    console.log(target.id + ":" + target.value);
    setState({
      ...state,
      [target.id]: isNaN(target.value)
        ? target.value
        : target.value === ""
        ? ""
        : parseInt(target.value),
    });

    console.log(state);
  }
  const handleOnLoad = () => {
    console.log("i start ooo");
    axios
      .get(
        `${globalConfig.systemCodesUrl}/CONTENT_TEMPLATE_TYPE_CODE`,
        apiHeader(token)
      )
      .then((res) => {
        const contentTypes = res.data;
        console.log("results", contentTypes);
        setContentTemplateTypeCodes(contentTypes);
      })
      .catch((err) => {
        console.log("here");
        console.log(err);
      });

    console.log("handleOnLoad() - loading id = " + state.contentTemplateTypeId);
    axios
      .get(
        `${globalConfig.apiDatahubUrl}/content-template-types/${state.contentTemplateTypeId}`,
        apiHeader(token)
      )
      .then((res) => {
        const templateType = res.data;
        console.log("templateType");
        console.log(templateType);
        setState(templateType);
        console.log("state");
        console.log(state);
      });
  };

  function onDelete() {
    let deleteID = state.contentTemplateTypeId;
    axios
      .delete(
        `${globalConfig.apiDatahubUrl}/content-template-types/` + deleteID,
        apiHeader(token)
      )
      .then((res) => {
        console.log("Delete Response:" + res.data);
        history.goBack();
      })
      .catch((err) => console.log("Err delete:" + err));
  }
  return (
    <form>
      <div className="container-fluid">
      <button
          type="button"
          className="btn btn btn-outline-secondary mt-2 mb-3"
          onClick={() => history.goBack()}
        >
          Go Back
        </button>
        <h4>Manage Content Template Types</h4>
        <hr />
        <h4>Selector</h4>
        <div className="form-group row">
          <label
            className="ContentTitle col-sm-2"
            value="Content Template Type"
          >
            Content Template Type
          </label>
          <select
            id="contentTemplateTypeId"
            onchange="submit()"
            className="form-control input-xlarge col-sm-8"
            value="#{ombContentTemplateTypeForm.currentContentTemplateType.contentTemplateTypeId}"
            valueChangeListener="#{ombContentTemplateTypeForm.get }"
          >
            <option value="#{ombContentTemplateTypeForm.contentTemplateTypeSelectList}" />
          </select>
        </div>

        <hr />
        <h4>Content Template Type Details</h4>
        <div columns="2">
          <div className="form-group row">
            <label
              className="ContentTitle col-sm-2"
              value="Content Template Type Description"
            >
              Content Template Type Description
            </label>
            <input
              id="contentTemplateTypeDescr"
              className="form-control input-xlarge col-sm-8"
              value={state.contentTemplateTypeDescr}
              onChange={handleChange}
            />
          </div>
          <div className="form-group row">
            <label
              className="ContentTitle col-sm-2"
              value="Content Template Value Code"
            >
              Content Template Value Code
            </label>
            <select
              id="contentTemplateValueCode"
              className="form-control input-xlarge col-sm-8"
              readOnly={true}
              value={state.contentTemplateValueCode}
              onChange={handleChange}
            >
              <option value={0}>Select Template Value Type</option>
              {contentTemplateTypeCodes.map(
                ({ systemCodeId, systemCodeValueValue, systemCodeValueId }) => (
                  <option key={systemCodeValueId} value={systemCodeId}>
                    {systemCodeValueValue}{" "}
                  </option>
                )
              )}
            </select>
          </div>
          <div className="form-group row">
            <label
              className="ContentTitle col-sm-2"
              value="Content Template Type CData"
            >
              Content Template Type CData
            </label>
            <input
              id="contentTemplateTypeCdata"
              className="form-control input-xlarge col-sm-8"
              readOnly={true}
              value={state.contentTemplateTypeCdata}
            />
          </div>
        </div>
        <hr />
        <div className="form-group row">
          <label
            className="ContentTitle col-sm-2"
            value="Last Updated By #{ombUserSession.getUserNameForId(contentTemplateForm.currentContentTemplate.lastUpdateUser)} on "
          >
            Last Updated By
          </label>
          <input
            className="form-control col-sm-1"
            readonly="readonly"
            value={state.lastUpdateUser}
          />
        </div>
        <div className="form-group row">
          <label
            className="ContentTitle col-sm-2"
            value="#{contentTemplateForm.currentContentTemplate.lastUpdateDate}"
          >
            Last Update Date
          </label>
          <input
            className="form-control col-sm-8"
            readonly="readonly"
            value={state.lastUpdateDate.slice(0, 16)}
            type="datetime-local"
          />
        </div>
        <hr />

       
        <button
          className="btn btn-danger"
          value="Delete"
          onClick={onDelete}
        >
          Delete
        </button>
        &nbsp;
        <button className="btn btn-success" value="Save" onClick={handleSave}>
          {" "}
          Save
        </button>
      </div>
    </form>
  );
};

export default ManageContentTemplateTypes;
